import React, { useEffect } from "react";
import "./styles/index.scss";
import {
  clickToLinkHandler,
  getPrimaryOrganizationIdForUser,
} from "../../../../helpers/utils";
import { connect } from "react-redux";
import Actions from "../../../../actions";
import { getDealById } from "../../../../reducers/selectors";

const BreadCrumbsWidget = (props) => {
  const {
    location: { pathname: path },
    investorName,
    user,
    dealId,
    deal,
    getDeal,
    name,
    investor,
    finalClosingSetMode,
    legalEntity,
  } = props;

  const orgId = deal?.organization_id
    ? deal.organization_id
    : getPrimaryOrganizationIdForUser(user);

  useEffect(() => {
    if (!deal && dealId) {
      getDeal(dealId);
    }
  }, [dealId, deal]);

  const getBreadcrumbs = () => {
    const result = [];
    if (path.indexOf("document-preview") > -1 && path.indexOf("edit") === -1) {
      let tmp = path.split("document-preview/");
      let parts = tmp[1].split("/version/");
      if (parts[0]) {
        if (deal) {
          result.push({
            name: "Deal: " + deal.series_of_preferred_stock_sold,
            link: "/" + orgId + "/deals/" + dealId + "/edit/deal-information",
          });
        }
        if (name) {
          if (finalClosingSetMode) {
            result.push({
              name: "Final Closing Set",
              link: "/" + orgId + "/deals/" + dealId + "/edit/closing",
            });
          } else {
            result.push({
              name: "Documents",
              link: "/" + orgId + "/deals/" + dealId + "/edit/documents",
            });
          }

          result.push({
            name: name,
          });
        }
      }
      if (parts[1] !== undefined && !finalClosingSetMode) {
        if (parts[1].indexOf("/view") > -1) {
          parts[1] = parts[1].split("/view")[0];
        }

        if (Number.isInteger(parts[1])) {
          result.push({
            name: "Version " + (Number(parts[1]) + 1),
          });
        } else if (parts[1].split("/") && parts[1].split("/").length) {
          result.push({
            name:
              "Version " + parts[1].split("/")[parts[1].split("/").length - 1],
          });
        }
      }
    } else if (
      path.indexOf("document-preview") > -1 &&
      path.indexOf("edit") > -1
    ) {
      result.push({
        name: name,
      });
      result.push({
        name: "Editing",
      });
    } else if (path.indexOf("investors/create") > -1) {
      result.push({
        name: "Investors",
        link: "/" + orgId + "/deals/" + dealId + "/edit/investors",
      });
      result.push({
        name: "Add New",
      });
    } else if (path.indexOf("investors/edit") > -1) {
      result.push({
        name: "Investors",
        link: "/" + orgId + "/deals/" + dealId + "/edit/investors",
      });

      if (investor) {
        let obj = {
          name: investorName
            ? investorName
            : investor.name
            ? investor.name
            : "",
        };
        if (path.indexOf("signer") > -1 && investor) {
          obj.link =
            "/" +
            orgId +
            "/deals/" +
            dealId +
            "/edit/investors/edit/" +
            investor.id;
        }
        result.push(obj);
      }

      if (path.indexOf("signer") > -1 && investor) {
        result.push({
          name: legalEntity?.legal_entity?.name,
        });
      }
    }
    return result;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <div className="bread-crumbs-container">
      <div className="bread-crumbs">
        {breadcrumbs.map((obj, key) => {
          return (
            <div key={"bread-crumb" + key} className="bread-crumb-item">
              <div
                className={(obj.link && "crumb link") || "crumb"}
                onClick={() => {
                  if (obj.link) {
                    clickToLinkHandler(obj.link);
                  }
                }}
              >
                {obj.name}
              </div>
              {key < breadcrumbs.length - 1 && (
                <div className="separator">/</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const { user } = state.auth;
  const { dealId, investor, legalEntityId } = props;
  return {
    user: user,
    deal: getDealById(dealId)(state),
    investor: investor,
    legalEntityId: legalEntityId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getDeal: function (dealId) {
    dispatch(Actions.getDeal(dealId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BreadCrumbsWidget);
